export enum ModalSizes {
  Small = 'small',
  Large = 'large',
  ExtraLarge = 'extra-large',
  FullScreen = 'full-screen',
}
